import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-clear-button";
interface ClearButtonProps {
    onClick: () => void;
    disabled?: boolean;
}
const ClearButton = ({ onClick, disabled = false }: ClearButtonProps) => {
    return (
        <Button
            disabled={disabled}
            style={ButtonStyles.None}
            cssClassName={CSS_CLASS_NAME}
            onClick={onClick}>
            {t("clearSearchResults")}
            <Icon type={Icons.Retry} />
        </Button>
    );
};

export default ClearButton;
